
export const converteTimeToMonth = (time: string) => {
    const date = new Date(time)
    return date.toLocaleString('default', {month: '2-digit', timeZone: 'UTC'}) +"/"+date.toLocaleString('default', {year: '2-digit', timeZone: 'UTC'})
}

export const converteTimeToDay = (time: string) => {
    const date = new Date(time)
    return date.toLocaleString('default', {weekday: 'long',  timeZone: 'UTC'}).split('')[0].toUpperCase()+" "+date.toLocaleString('default', {day: '2-digit',  timeZone: 'UTC'})+"/"+date.toLocaleString('default', {month: '2-digit',  timeZone: 'UTC'}) +"/"+date.toLocaleString('default', {year: '2-digit',  timeZone: 'UTC'})
}

export const converteTimeToHour = (time: string) => {
    const date = new Date(time)
    return converteTimeToDay(time)+' '+date.getHours()+"h"
}

export const converteTimeToYear = (time: string) => {
    const date = new Date(time)
    return date.toLocaleString('default', {year: 'numeric',  timeZone: 'UTC'})
}

export const converteTimeToString = (time: string, type: 'mo'|'d'|'h'|'y') => {
    switch (type) {
        case 'mo':
            return converteTimeToMonth(time)
        case 'd':
            return converteTimeToDay(time)
        case 'h':
            return converteTimeToHour(time)
        case 'y':
            return converteTimeToYear(time)
        default:
            return ''
    }
}

export const calculateDifferenceDate = (date1: Date, date2: Date, type: 'h' | 'd' | 'mo'): number => {
    const diffInMs = Math.abs(date2.getTime() - date1.getTime());

    switch (type) {
        case 'h':
            return diffInMs / (1000 * 60 * 60); // Convertir les millisecondes en heures
        case 'd':
            return diffInMs / (1000 * 60 * 60 * 24); // Convertir les millisecondes en jours
        case 'mo':
            const year1 = date1.getUTCFullYear();
            const year2 = date2.getUTCFullYear();
            const month1 = date1.getUTCMonth();
            const month2 = date2.getUTCMonth();
            return (year2 - year1) * 12 + (month2 - month1); // Calculer la différence en mois
        default:
            throw new Error('Type non supporté');
    }
}


